module.exports = __webpack_public_path__ + "static/media/parking-selected.fd6c593e.svg";